import React, { useReducer, useContext, useRef } from "react";
import PrimeReact from "primereact/api";

import GlobalContext from "../../isp._comun/contexto/GlobalContext";

import DialogoInteractivoDeCliente from "../../isp.pantalla.principal.clientes/componentes/DialogoInteractivoDeCliente";
import DialogoInteractivoDeQueryClientes from "../../isp.pantalla.principal.clientes/componentes/DialogoInteractivoDeQueryClientes";

import DialogoInteractivoDeItem from "../../isp.pantalla.principal.items/componentes/DialogoInteractivoDeItem";
import DialogoInteractivoDeQueryDeItems from "../../isp.pantalla.principal.items/componentes/DialogoInteractivoDeQueryDeItems";

import VentanaClienteAFacturar from "../../isp.pantalla.principal.clientes/reductores/ventanas/VentanaClienteAFacturar";
import VentanaQueryClientesAFacturar from "../../isp.pantalla.principal.clientes/reductores/ventanas/VentanaQueryClientesAFacturar";
import VentanaItem from "../../isp.pantalla.principal.items/reductores/ventanas/VentanaItem";
import VentanaQueryItems from "../../isp.pantalla.principal.items/reductores/ventanas/VentanaQueryItems";

import PrincipalReducer from "../reductores/PrincipalReducer";
import PantallaPrincipal from "./layouts/PantallaPrincipal";
// import { v4 } from "uuid";

// import ClienteAFacturar from "../../entidades/ClienteAFacturar";
// import DataDeRespuestas_Facturacion from "../../servicios/DataEstaticaDeRespuestas.json";

const PantallaInteractivaPrincipal = () => {
    const initialState = {
        ventanas: [],
        // banderaDeNotificacionEventos:true
        banderaCerrandoSesion: false,
    };

    const [state, dispatchPrincipal] = useReducer(PrincipalReducer, initialState);

    // PrimeReact.autoZIndex = false;
    PrimeReact.autoZIndex = true;

    PrimeReact.zIndex = {
        modal: 900, // dialog, sidebar
        overlay: 1000, // dropdown, overlaypanel
        menu: 1000, // overlay menus
        tooltip: 1100, // tooltip
        toast: 1200, // toast
    };

    const lista_ventanas = state.ventanas.map((ventana) => {
        // if (ventana.tipo === DialogType.CLIENTE_A_FACTURAR) {
        if (ventana instanceof VentanaClienteAFacturar) {
            return <DialogoInteractivoDeCliente key={ventana.id} ventana={ventana} />;
        }

        // if (ventana.tipo === DialogType.QUERY_CLIENTES_A_FACTURAR) {
        if (ventana instanceof VentanaQueryClientesAFacturar) {
            return <DialogoInteractivoDeQueryClientes key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaItem) {
            return <DialogoInteractivoDeItem key={ventana.id} ventana={ventana} />;
        }

        if (ventana instanceof VentanaQueryItems) {
            return <DialogoInteractivoDeQueryDeItems key={ventana.id} ventana={ventana} />;
        }

        return null;
    });

    const refPantallaPrincipal = useRef(null);

    const notificar = function (notificacion) {
        refPantallaPrincipal.current.notificar(notificacion);
    };

    /* const getVentanaCargadaEnLaLista = function (ventanaAAbrir) {
        const ventanaReemplazante = state.ventanas.find((ventana) => {
            if (ventana.puedeHacersePasarPor(ventanaAAbrir)){
                return true;
            } else {
                return false;
            }
        });
        if (ventanaReemplazante) {
            return ventanaReemplazante;
        } else {
            ventanaAAbrir.posicionZ = state.ventanas.length + 1;
            state.ventanas.push(ventanaAAbrir);
            return ventanaAAbrir;
        }
    }; */

    const values = useContext(GlobalContext);

    /* return (
        <GlobalContext.Provider
            value={{
                ...values,
                lista_ventanas,
                // evento: state.evento,
                //   abrirVentanaClienteAFacturar,
                //   abrirVentanaCrearFia,
                // abrirVentanaQueryFias,
                //   cerrarVentana,
                //   posicionarPrimero,
                //   notificarRegistroDeFia,
                dispatchPrincipal,
                notificar,
                // cerrarSesion
            }}
        >
            <PantallaPrincipal ref={refPantallaPrincipal} />
        </GlobalContext.Provider>
    );  */

    values.lista_ventanas = lista_ventanas;
    values.dispatchPrincipal = dispatchPrincipal;
    values.notificar = notificar;
    values.estadoPrin = state;
    return <PantallaPrincipal ref={refPantallaPrincipal} />;
};

export default PantallaInteractivaPrincipal;
